var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$options.filters.currentLocale(_vm.auction.description))?_c('div',{staticClass:"ta-auction-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.currentLocale(_vm.auction.description))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }